export const acceptPayloadAdapter = (trxId, codeInternal, email) => {
	return {
		trx_id: trxId,
		code_internal: codeInternal,
		status: 'RA',
		signature: email,
	};
};
